import {Typography} from "@mui/material";
import {translateKey} from "utils/fieldsFormatters";
import CookieConsent from "react-cookie-consent";
import { use } from "react";
import {LanguageContext} from "context/LanguageContext";
import {COLORS} from "styles/colors";
import terms from "assets/pdf/dbn_terms_pl_en.pdf"
import policy from "assets/pdf/dbn_policy_pl_en.pdf"

interface CookieConsentBarProps {
    className: string
    footerHeight: number | string
}

const CookieConsentBar = ({className, footerHeight}: CookieConsentBarProps) => {
    const {language} = use(LanguageContext);

    const cookieConsentProps = {
        buttonText: translateKey('understand', language),
        style: {
            marginBottom: className === 'basic-cookie-fixed' ? footerHeight : 0,
            background: COLORS.light,
        },
        buttonStyle: {
            background: COLORS.dark,
            color: COLORS.white
        }
    }
    return <CookieConsent {...cookieConsentProps} cookieName={'basicCookieConsent'} containerClasses={className}>


        <Typography>{translateKey('cookieConsent', language)}&nbsp;
            <a href={terms} rel="noreferrer" target="_blank" className={'cookie-link'}>{translateKey('termsCookie', language)}</a>&nbsp;
            {translateKey('and', language)}&nbsp;
            <a href={policy} rel="noreferrer" target="_blank" className={'cookie-link'}>{translateKey('privacyPolicyCookie', language)}</a>.
        </Typography>

    </CookieConsent>
}

export default CookieConsentBar